// extracted by mini-css-extract-plugin
export default {"select":"share_modal-module___select___d91eb94f","info":"share_modal-module___info___e57db128"};